module.exports = __webpack_public_path__ + "static/media/BE.9acc9bc0.svg";